import { useEffect, useRef, useState } from 'react';
import { Table, Input, Button, Select, Form, InputNumber, Radio, Space, Tag, Row, Col } from 'antd';
// import { EditOutlined, DeleteOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import EventEmitter from '../utils/eventEmitter';
import { ActionColumn } from '../utils/tableMockData';



const EditableCell = ({ editing, dataIndex, title, form, inputType, options, record, index, children, ...restProps }) => {
  const onChange = (option, form, dataIndex) => EventEmitter.dispatch('selected', {option, form, key:record.key, dataIndex});
  const onDeselected = (value, form, taxes, dataIndex) => EventEmitter.dispatch('deselected', {value, taxes, form, dataIndex});
  

  const inputNode = inputType === 'select' ? 
    <Select 
      onDeselect={(v)=> (dataIndex === 'taxes' || dataIndex === 'analytics') && onDeselected(v, form, options, dataIndex)} 
      mode={(dataIndex === 'taxes' || dataIndex==='analytics') && 'tags'} 
      options={options} 
      onChange={(value, option)=>onChange(option, form, dataIndex)} 
    /> :
    inputType === 'radio' ? 
    <Radio.Group className='flex flex-column'>
      <Space direction='vertical'>
        <Radio value={'debit'} className='font-normal'>Debit</Radio>
        <Radio value={'credit'} className='font-normal'>Credit</Radio>
      </Space>
    </Radio.Group> :
    inputType === 'number' ?
    <InputNumber />
    : <Input />;

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item name={dataIndex} className='m-0' >
          {inputNode}
        </Form.Item>
      ) : (
        // children
        <>{
            inputType === 'select' && dataIndex === 'taxes' ?
            form.getFieldValue('tax'+record.key) && 
            form.getFieldValue('tax'+record.key).map(tax => <Tag key={tax}>{tax}</Tag>) : 
            inputType === 'select' && dataIndex === 'analytics' ?
            form.getFieldValue('analytic'+record.key) && 
            form.getFieldValue('analytic'+record.key).map(analytic => <Tag key={analytic}>{analytic}</Tag>) : 
            inputType === 'select' && dataIndex === 'account_id' ? 
            form.getFieldValue(record.account_id) : 
            inputType === 'select' && dataIndex === 'product_id' ?
            form.getFieldValue(dataIndex) : 
            children 
          }</>
      )}
    </td>
  );
};


 
const InvoiceTable = ({name, dataSource, refund, default_account, invoiceNumber, entries, products, setJournalEntries, setInvoiceLines, columns, accounts, taxes, setTax, tax, analytics, status }) => {
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;

  const edit = async (record) => {
    form.setFieldsValue({ ...record })
    setEditingKey(record.key)
  };

  const cancel = () => {
    setEditingKey('')
  }

  const saveInvoiceLines = async (record) => {
    try {
      const key = record.key;
      // console.log(record)
      const row = await form.validateFields();
      // console.log(row)
      const newData = Object.assign([], dataSource);
      const index = newData.findIndex((item) => key === item.key)
      // console.log(newData, index, newData[index])
      if (index > -1) {
        let item = newData[index];
        item['subtotal'] = row['quantity'] * row['price'];
        newData.splice(index, 1, { ...item, ...row });
        setInvoiceLines(newData);
        
        let entry_ = Object.assign([], entries);
        let taxList = Object.assign([], tax);
        newData.forEach((item, invId) => {
          const index = entry_.findIndex(entry => entry.key === item.key);
          const defaultIndex = entry_.findIndex(entry => entry.account_id === (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693"));
          let entryObj1 = {link: item.key, key: item.key, account_id: item['account_id'], analytics: item.analytics, taxes: item.taxes, label: item['label'], type: name==='invoice' ? 'credit' : 'debit', amount: item['subtotal']};
          if (refund && name ==='invoice') entryObj1['type'] = 'debit'
          else if (refund && name ==='bill') entryObj1['type'] = 'credit';

          if (index === -1) {
            entry_.push(entryObj1);
          }else {
            entry_[index] = entryObj1;
          }

          // Taxes calculation
          if (item.taxes.length > 0) {
            // loop through invoice taxes
            item.taxes.forEach((invoiceTax, taxId) => {
              
              // find the invoice tax object
              let invoiceTaxObj = taxes.find(tax => tax._id === invoiceTax);
              let foundTaxIndex = entry_.findIndex(entry=> entry.label === invoiceTaxObj.name);

              if (foundTaxIndex === -1){
                
                // create the tax entry object for the invoice tax
                let taxEntryObj = {link: item.key, key: 50 + taxId, type: name==='invoice' ? 'credit' : 'debit', label: invoiceTaxObj.name, account_id: "c118ce25-1312-414c-ba8d-17c8d4b1e318", amount: 0 };
                if (refund && name === 'invoice') taxEntryObj['type'] = 'debit'
                else if (refund && name === 'bill') taxEntryObj['type'] = 'credit';
                // define the various tax computations
                switch (invoiceTaxObj.tax_computation) {
                  case 'percent_of_price':
                    taxEntryObj['amount'] += (parseFloat(invoiceTaxObj.amount / 100) * item.subtotal).toFixed(2) * 1;
                    // setTax(prev => prev + taxEntryObj['amount']);
                    break;
                  case 'percent_of_price_included':
                    taxEntryObj['amount'] += (parseFloat(item.subtotal / 1 - (invoiceTaxObj.amount / 100))).toFixed(2) * 1;
                    // setTax(prev => prev + taxEntryObj['amount']);
                    break;
                  case 'fixed':
                    taxEntryObj['amount'] += (parseFloat(item.subtotal + invoiceTaxObj.amount )).toFixed(2) * 1;
                    // setTax(prev => prev + taxEntryObj['amount']);
                    break;
                };
                let index = taxList.findIndex(item => item.label === taxEntryObj.label);
                if (index === -1) {
                  taxList.push(taxEntryObj);
                }else {
                  taxList[index] = taxEntryObj;
                }
                setTax(taxList);
                entry_.push(taxEntryObj);
              }
            });
          }
          // DEFAULT INVOICE OR PRODUCT ACCOUNT
          if (defaultIndex === -1) {
            let entryObj2 = {key: 100, account_id: name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693", type: name==='invoice' ? 'debit' : 'credit', label: invoiceNumber, amount: entry_.filter(entry => entry.account_id !== (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693")).reduce((prev, current) => (current.amount + prev), 0).toFixed(2)};
            if (refund && name ==='invoice') entryObj2['type'] = 'credit'
            else if (refund && name ==='bill') entryObj2['type'] = 'debit';

            entry_.splice(0, 0, entryObj2);

          }else {
            let entryObj2 = {key: 100, account_id: name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693", type: name==='invoice' ? 'debit' : 'credit', label: invoiceNumber, amount: entry_.filter(entry => entry.account_id !== (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693")).reduce((prev, current) => (current.amount + prev), 0).toFixed(2)};
            if (refund && name ==='invoice') entryObj2['type'] = 'credit'
            else if (refund && name ==='bill') entryObj2['type'] = 'debit';

            entry_[defaultIndex] = entryObj2;
          }
        });
        setJournalEntries(entry_);
        setEditingKey('');
      }
    } catch (err) {
      console.log('Validate Failed:', err)
    }
  }

  const addInvoiceEntry = () => {
    let invoiceLines_ = [...dataSource];
    let entryObj = {
      key: dataSource.length + 1,
      product_id: '',
      account_id: default_account.account ? default_account.account : "",
      label: '',
      price: 0,
      analytics: [],
      quantity: 1,
      taxes: []
    }
    invoiceLines_.push(entryObj)
    form.setFieldsValue({ ...entryObj })
    setInvoiceLines(invoiceLines_);
    setEditingKey(dataSource.length + 1);
    if (default_account.account) {
      let account = accounts.find((account) => account._id === default_account.account);
      form.setFieldValue(`${account._id}`, `${account.code} ${account.name}`);
    }
  }

  const reCalculateEntry = (entries_, invoices) => {
    let entry_ = Object.assign([], entries_);
    let taxList = Object.assign([], tax);
    invoices.forEach((item, invId) => {
      const index = entry_.findIndex(entry => entry.key === item.key);
      const defaultIndex = entry_.findIndex(entry => entry.account_id === (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693"));
      let entryObj1 = {link: item.key, key: item.key, account_id: item['account_id'], analytics: item.analytics, label: item['label'], type: name==='invoice' ? 'credit' : 'debit', amount: item['subtotal']};
      if (refund && name ==='invoice') entryObj1['type'] = 'debit'
      else if (refund && name ==='bill') entryObj1['type'] = 'credit';

      if (index === -1) {
        entry_.push(entryObj1);
      }else {
        entry_[index] = entryObj1;
      }

      // Taxes calculation
      if (item.taxes.length > 0) {
        // loop through invoice taxes
        item.taxes.forEach((invoiceTax, taxId) => {
          
          // find the invoice tax object
          let invoiceTaxObj = taxes.find(tax => tax._id === invoiceTax);
          let foundTaxIndex = entry_.findIndex(entry=> entry.label === invoiceTaxObj.name);

          if (foundTaxIndex === -1){
            
            // create the tax entry object for the invoice tax
            let taxEntryObj = {link: item.key, key: 50 + taxId, type: name==='invoice' ? 'credit' : 'debit', label: invoiceTaxObj.name, account_id: "c118ce25-1312-414c-ba8d-17c8d4b1e318", amount: 0 };
            if (refund && name === 'invoice') taxEntryObj['type'] = 'debit'
            else if (refund && name === 'bill') taxEntryObj['type'] = 'credit';
            // define the various tax computations
            switch (invoiceTaxObj.tax_computation) {
              case 'percent_of_price':
                taxEntryObj['amount'] += (parseFloat(invoiceTaxObj.amount / 100) * item.subtotal).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'percent_of_price_included':
                taxEntryObj['amount'] += (parseFloat(item.subtotal / 1 - (invoiceTaxObj.amount / 100))).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
              case 'fixed':
                taxEntryObj['amount'] += (parseFloat(item.subtotal + invoiceTaxObj.amount )).toFixed(2) * 1;
                // setTax(prev => prev + taxEntryObj['amount']);
                break;
            };
            let index = taxList.findIndex(item => item.label === taxEntryObj.label);
            if (index === -1) {
              taxList.push(taxEntryObj);
            }else {
              taxList[index] = taxEntryObj;
            }
            setTax(taxList);
            entry_.push(taxEntryObj);
          }
        });
      }
      // DEFAULT INVOICE OR PRODUCT ACCOUNT
      if (defaultIndex === -1) {
        let entryObj2 = {key: 100, account_id: name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693", type: name==='invoice' ? 'debit' : 'credit', label: invoiceNumber, amount: entry_.filter(entry => entry.account_id !== (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693")).reduce((prev, current) => (current.amount + prev), 0).toFixed(2)};
        if (refund && name ==='invoice') entryObj2['type'] = 'credit'
        else if (refund && name ==='bill') entryObj2['type'] = 'debit';

        entry_.splice(0, 0, entryObj2);

      }else {
        let entryObj2 = {key: 100, account_id: name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693", type: name==='invoice' ? 'debit' : 'credit', label: invoiceNumber, amount: entry_.filter(entry => entry.account_id !== (name === 'invoice' ? "1f048064-4015-4fcf-95cd-63526ff3e37d" : "073b608d-cb2e-4f38-85a4-e900fac24693")).reduce((prev, current) => (current.amount + prev), 0).toFixed(2)};
        if (refund && name ==='invoice') entryObj2['type'] = 'credit'
        else if (refund && name ==='bill') entryObj2['type'] = 'debit';

        entry_[defaultIndex] = entryObj2;
      }
    });
    return entry_;
    // setJournalEntries(entry_);
  }


  const removeInvoice = (record) => {
    let key = record.key;
    let invoices = dataSource.filter((item) => item.key !== key);
    let entries_ = entries.filter(item => item.link !== key);
    let taxes = tax.filter(item => item.link !== key);
    // setInvoiceLines(invoices);
    if (invoices.length === 0) {
      setJournalEntries([]);
      setInvoiceLines(invoices);
    }else {
      const entry = reCalculateEntry(entries_, invoices);
      setInvoiceLines(invoices);
      setJournalEntries(entry);
      
    }
    setTax(taxes);
  }

  columns[columns.length - 1]['render'] = (_, record) =>
    ActionColumn(_, record, isEditing, saveInvoiceLines, edit, cancel, removeInvoice)

  if (status === 'posted')
    delete columns[columns.length - 1]['render']



  useEffect(() => { 
    EventEmitter.subscribe('selected', data => {
      const { option, form, key, dataIndex } = data;
      const { label, value } = option;
      if (dataIndex === 'taxes') {
        form.setFieldValue('tax'+key, option.map(tax => tax.label));
      }else if (dataIndex === 'analytics'){
        form.setFieldValue('analytic'+key, option.map(analytic => analytic.label));
      }else {
        form.setFieldValue(value, option.label);
      }
    });

    EventEmitter.subscribe('deselected', data => {
      const { value, taxes, form, dataIndex } = data;
      let entries_ = name === 'journal entries' ? Object.assign([], dataSource) : Object.assign([], entries);
      let tax_ = Object.assign([], tax);
      console.log(entries, dataSource)
      if (dataIndex === 'taxes') {
        // if (taxes !== undefined) {
          let taxObj = taxes.find(tax => tax.value === value);
          let findEntryTaxIndex = entries_.findIndex(entry => entry.label === taxObj.label);
          let findTax = tax_.findIndex(item => item.label === taxObj.label);
          entries_.splice(findEntryTaxIndex, 1);
          tax_.splice(findTax, 1);
          setJournalEntries(entries_);
          setTax(tax_);
        // }
      }
    });

    return () => {
      EventEmitter.unsubscribe('selected');
      EventEmitter.unsubscribe('deselected');
    }
  },[]);


  useEffect(() => {
    if (dataSource) {
      dataSource.forEach((invoiceLine) => {
        let taxes_ = taxes.filter((tax) => invoiceLine.taxes.includes(tax._id))
        form.setFieldValue('tax'+invoiceLine.key, taxes_.map(tax => tax.name));
        let account = accounts.find((account) => account._id === invoiceLine.account_id);
        form.setFieldValue(`${account._id}`, `${account.code} ${account.name}`);
        if (invoiceLine.analytics !== undefined) {
          let analytics_ = analytics.filter((analytic) => invoiceLine.analytics.includes(analytic._id))
          form.setFieldValue('analytic'+invoiceLine.key, analytics_.map(analytic => analytic.name));
        }
      });
    }
  },[]);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
    ...col,
    onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      form: form,
      // selectedValue: selectedValue,
      inputType: (col.dataIndex === 'account_id' || col.dataIndex === 'taxes' || col.dataIndex === 'product_id' || col.dataIndex === 'analytics') ? 'select' : (col.dataIndex === 'type') ? 'radio' : (col.dataIndex === 'amount' || col.dataIndex === 'price' || col.dataIndex === 'quantity') ? 'number' : 'text',
      options: 
        col.dataIndex === 'account_id' && accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`})) ||
        col.dataIndex === 'taxes' && taxes.map(tax => ({value: tax._id, label: tax.name})) ||
        col.dataIndex === 'analytics' && analytics.map(analytic => ({value: analytic._id, label: analytic.name})) ||
        col.dataIndex === 'product_id' && products.map(product => ({value: product.id, label: product.name})),
      editing: isEditing(record),
    }),
  }});

  return (
    <Form 
        form={form} 
        component={false} 
        initialValues={{}}
        labelAlign='right'
        labelCol={{span: 15}}
      >
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={dataSource}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={false}
        rowKey={'link'}

      />
      {status !== 'posted' && <Button onClick={addInvoiceEntry}>Add Entry</Button>}
      <div>
        <Row className='flex justify-end'>
          <Col md={{span: 9}}>
            <Form.Item label='Untaxed Amount' className='mb-0 font-semibold'>
              <Input className='border-0 p-1 pe-2 text-sm text-end font-bold' disabled value={'GHc '+dataSource.reduce((prev, current) => (current.subtotal * 1 + prev), 0).toFixed(2)}/>
            </Form.Item>
          </Col>
        </Row>
        <Row className='flex justify-end'>
          <Col md={{span: 9}}>
            {tax.map(tax_ => 
              <Form.Item key={tax_.key} label={tax_.label} className='mb-0 font-semibold'>
                <Input className='border-0 border-b-2 p-1 pe-2 text-sm text-end font-semibold' disabled value={`GHc ${tax_.amount}`}/>
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row className='flex justify-end'>
          <Col md={{span: 9}}>
            <Form.Item  label='Total' className='mb-0 font-semibold'>
              <Input className='border-0 p-1 pe-2 text-sm text-end font-bold' disabled value={'GHc '+(tax.reduce((prev, current) => (current.amount + prev), 0) + dataSource.reduce((prev, current) => (current.subtotal * 1 + prev), 0)).toFixed(2)}/>
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default InvoiceTable;
